define('plugins/musicfavourite/nls/management',{
    'en-gb': {
        'management': {
            'remove': 'Remove?',
            'confirm': 'Yes',
            'cancel': 'No'
        }
    },
    'cy-gb': { //WELSH
        'management': {
            'remove': 'Dileu?',
            'confirm': 'Ie',
            'cancel': 'Na'
        }
    },
    'ga-gb': { //IRISH
        'management': {
            'remove': 'Bain?',
            'confirm': 'T\341',
            'cancel': 'N\355l'
        }
    },
    'gd-gb': { //SCOTTISH
        'management': {
            'remove': 'Thoir \340s?',
            'confirm': 'Lean ort',
            'cancel': 'Air ais'
        }
    }
});

